import { useLanguage } from '@/contexts/LanguageContext';

export default function PartnershipHero() {
  const { t } = useLanguage();

  const tags = [
    { icon: 'ri-flask-line', label: t('技術導入', 'Technology Implementation', '技術導入') },
    { icon: 'ri-map-pin-line', label: t('區域經銷', 'Regional Distribution', '地域販売代理') },
    { icon: 'ri-links-line', label: t('策略夥伴', 'Strategic Partners', '戦略的パートナー') },
    { icon: 'ri-leaf-line', label: t('ESG 專案', 'ESG Projects', 'ESGプロジェクト') },
    { icon: 'ri-recycle-line', label: t('塑膠再生供應鏈', 'Plastic Recycling Supply Chain', '廃プラスチック再生サプライチェーン') },
  ];

  return (
    <section className="relative min-h-[560px] md:min-h-[640px] flex items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-top"
        style={{
          backgroundImage:
            'url(https://readdy.ai/api/search-image?query=business%20partnership%20handshake%20meeting%20sustainable%20circular%20economy%20company%20collaboration%20modern%20office%20green%20technology%20B2B%20professional%20corporate%20photography%20clean%20environment%20green%20and%20blue%20accent%20lighting%20wide%20angle%20high%20resolution&width=1440&height=640&seq=partnership-hero-v1&orientation=landscape)',
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/42 via-black/28 to-black/12" />
      <div className="absolute top-0 right-0 w-[600px] h-[600px] opacity-20 pointer-events-none" style={{ background: 'radial-gradient(circle, rgba(0,184,148,0.30) 0%, transparent 65%)', zIndex: 2 }} aria-hidden="true" />
      <div className="absolute bottom-0 left-1/4 w-[450px] h-[350px] opacity-15 pointer-events-none" style={{ background: 'radial-gradient(circle, rgba(2,115,194,0.25) 0%, transparent 65%)', zIndex: 2 }} aria-hidden="true" />

      <div className="relative w-full max-w-screen-xl mx-auto px-4 md:px-6 py-20" style={{ zIndex: 3 }}>
        <div className="max-w-[700px] bg-black/20 backdrop-blur-[2px] rounded-2xl px-8 py-8 md:px-10 md:py-10">
          <p className="text-[1rem] font-semibold text-brand-green uppercase tracking-widest mb-4">
            {t('合作模式與經銷夥伴', 'Partnership & Distribution', 'パートナーシップ・販売代理')}
          </p>
          <h1
            className="font-bold text-white mb-6"
            style={{ fontSize: 'clamp(2rem, 4.2vw, 2.75rem)', lineHeight: '1.3' }}
          >
            {t('一起把塑膠再生，變成可規模化的', 'Together, Turn Plastic Recycling into a', '一緒にプラスチック再生を')}
            <span
              style={{
                background: 'linear-gradient(90deg, #00B894 0%, #4FC3F7 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
              }}
            >
              {t('低碳商機', 'Scalable Low-Carbon Business Opportunity', 'スケーラブルな低炭素ビジネスチャンスへ')}
            </span>
          </h1>
          <p className="text-white/85 mb-9 max-w-[640px]" style={{ fontSize: '1.1875rem', lineHeight: '1.75' }}>
            {t(
              '聚量歡迎塑膠回收廠、造粒廠、材料經銷商、品牌端、政府單位、ESG 顧問與產業整合商，透過技術導入、專案合作、區域經銷與策略夥伴模式，共同拓展循環經濟市場。',
              'PolyQ welcomes plastic recyclers, compounders, material distributors, brand owners, government agencies, ESG consultants, and industry integrators to jointly expand the circular economy market through technology implementation, project cooperation, regional distribution, and strategic partnership models.',
              '聚量はプラスチックリサイクル業者・造粒業者・材料販売代理店・ブランドオーナー・政府機関・ESGコンサルタント・産業統合業者を歓迎します。技術導入・プロジェクト協力・地域販売代理・戦略的パートナーシップを通じてサーキュラーエコノミー市場を共に拡大しましょう。'
            )}
          </p>
          <div className="flex flex-wrap gap-2.5">
            {tags.map((tag) => (
              <div key={tag.label} className="inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full bg-white/10 border border-white/25 backdrop-blur-sm">
                <i className={`${tag.icon} text-brand-green text-sm`}></i>
                <span className="text-white/90 text-[0.9375rem] font-medium whitespace-nowrap">{tag.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
